import React from 'react';
import { Carousel } from '@vds/carousels';
import { BroadbandLabel } from '@plans/tiles';

export const CarouselComponent = (data) => (
  <Carousel
    layout="1UP"
    gutter="12px"
    peek="minimum"
    surface="light"
    paginationInset="12px"
    pagination={{
      kind: 'lowContrast',
      hideBorder: true,
      floating: true,
    }}
    paginationDisplay="onHover"
    aspectRatio="1:1"
    data={data?.data}
    renderItem={(props) => <BroadbandLabel {...props} />}
  />
);
